const Template = `<div>
	<left-menu :users="users" @line-click="userClick"></left-menu>
	
	<info-window v-if = "selectedUser" :selected="selectedUser" @update-user="updateUser" ></info-window>
</div>
`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page3_users/template.js